module.exports = __webpack_public_path__ + "static/media/clock.c1f1c877.svg";